module.exports = __webpack_public_path__ + "static/media/topbot.8ae9de10.svg";